export default "__VITE_ASSET__EtOKLLjt__"